import { Alert, AlertTitle, Svg } from '@repo/ui';
import { useEffect, useState } from 'react';

export const PartnerDiscountBanner = ({
  partnerName,
  defaultFeeRate,
  feeRate,
  endAt
}: {
  partnerName: string;
  defaultFeeRate: string;
  feeRate: string;
  endAt: string;
}) => {
  const [formattedEndAt, setFormattedEndAt] = useState('');
  const [hide, setHide] = useState(false);

  useEffect(() => {
    if (!endAt) return;
    let timer: ReturnType<typeof setTimeout>;

    // 서버에서 보내오는 시간은 지역 시간이 적용 안된 값이라 보정
    const end = new Date(endAt);
    const newTime = end.getTime() - 9 * 60 * 60 * 1000;
    end.setTime(newTime);

    const month = end.getMonth() + 1;
    const day = end.getDate();
    const hour = end.getHours();
    const minutes = end.getMinutes();

    const hourStr = hour < 10 ? `0${hour}` : `${hour}`;
    const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

    setFormattedEndAt(`${month}월 ${day}일 ${hourStr}:${minutesStr}`);

    const now = new Date();
    const remainedDiscountTime = end.getTime() - now.getTime();

    if (remainedDiscountTime > 0) {
      timer = setTimeout(() => {
        setHide(true);
      }, remainedDiscountTime);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [endAt]);

  if (hide) {
    return null;
  }
  return (
    <section className={'mb-normal-large page-padding pb-4'}>
      <div className={'max-w-[520px] mx-auto page-padding'}>
        <Alert
          className={'p-normal-small bg-neutral-background-lowest'}
          graphic={<Svg src={'icg_coin_sm.svg'} width={20} height={20} />}
          variant="custom"
          size="small"
        >
          <AlertTitle className="grow text-gray-800 body-13 break-words">
            {formattedEndAt && (
              <div className={'text-neutral-foreground-low'}>
                {formattedEndAt}까지 신청 시,
                <br />
              </div>
            )}
            <span>{partnerName ?? ''} 회원의 이용료는&nbsp;</span>
            {!formattedEndAt && <br />}
            <span className="line-through">{defaultFeeRate}</span>
            <span>
              &#x2192;
              <span className="text-violet-600 whitespace-nowrap">{feeRate}%</span>
              로&nbsp;
            </span>
            적용돼요.
          </AlertTitle>
        </Alert>
      </div>
    </section>
  );
};
